import React from 'react'
import './main.scss'
// import Img1 from '../../assets/laptop.png'
import Img1 from '../../assets/laptop-2.png'
import Img2 from '../../assets/ShurMain.png'
import { Button, Typography } from '@mui/material'
import TypeAnimation from 'react-type-animation';

export default function Main() {
  return (
    <div className="main">
        <div className="main__container">
            <div className="main__f1 f1">
                <Typography variant='h2'>
                    <span>Clickanti</span> 
                    <TypeAnimation 
                    cursor={false}
                    sequence={['защищает', 4000, 'помогает', 4000]}
                    wrapper="h2"
                    repeat={Infinity}
                    className='type-auto'
                    /> 
                    от скликивания рекламы
                </Typography>
                <Typography variant='inherit'>
                Сервис, который помогает бороться со скликиванием рекламы конкурентами
                </Typography>
                <a href='https://panel.clickanti.ru/reg'>
                    <Button variant='contained'>Попробовать бесплатно</Button>
                </a>
            </div>
            <div className="main__f2 f2">
                <div className="f2__pic">
                    <img src={Img1} alt="" />
                </div>
                <div className="f2__fone">
                    <img src={Img2} alt="" />
                </div>
            </div>
        </div>
    </div>
  )
}
